import { useState } from 'react';
import { updateProfile } from '../services/authApi';
import { User } from '../types/entities';
import { useApi } from './useApi';
import { toUserEntity } from '../services/authApi/authApi.types';

interface ProfileData {
  name: string;
}

interface ProfileUpdateProps {
  currentUser: User;
  onUserUpdate: (user: User) => void;
}

/**
 * プロフィール更新のためのカスタムフック
 */
export const useProfileUpdate = ({ currentUser, onUserUpdate }: ProfileUpdateProps) => {
  const [profileData, setProfileData] = useState<ProfileData>({
    name: currentUser.name || '',
  });
  const [profileMessage, setProfileMessage] = useState<string>('');

  // API呼び出しのフックを利用
  const updateProfileApi = useApi(
    async (data: ProfileData) => {
      // バックエンドの UpdateProfileRequestSchema は .strict() で name のみを許可しているため、
      // 未定義フィールド（旧: hospital_id/role）を含めると常に400エラーになる
      const response = await updateProfile({ name: data.name });
      return response;
    },
    {
      successMessage: 'プロフィールを更新しました',
      errorMessage: '更新に失敗しました',
      onSuccess: (response) => {
        // レスポンスからUser型に変換して親コンポーネントに反映
        if (response.user) {
          onUserUpdate(toUserEntity(response.user));
        }
        
        // 成功メッセージを一定時間後に消す
        setProfileMessage('プロフィールを更新しました');
        setTimeout(() => {
          setProfileMessage('');
        }, 3000);
      },
    }
  );

  // フォーム変更ハンドラ
  const handleProfileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProfileData((prev: ProfileData) => ({
      ...prev,
      [name]: value
    }));
  };

  // フォーム送信ハンドラ
  const handleProfileSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // 名前のみ更新する
    await updateProfileApi.execute({ name: profileData.name });
  };

  return {
    profileData,
    profileMessage,
    isUpdating: updateProfileApi.loading,
    error: updateProfileApi.error,
    handleProfileChange,
    handleProfileSubmit,
  };
}; 
